import * as React from "react";
import GlobalStyles from "@mui/material/GlobalStyles/GlobalStyles";
import TopBar from "../../../components/TopBarV2";
import Container from "@mui/material/Container/Container";
import Typography from "@mui/material/Typography/Typography";
import Stack from "@mui/material/Stack/Stack";
import MenuItem from "@mui/material/MenuItem/MenuItem";
import TextField from "@mui/material/TextField/TextField";
import Button from "@mui/material/Button/Button";
import StepperProjectSetup from "../../../components/stepper-ps";
import Spinner from "../../../components/spinner";
import RemoveIcon from "@mui/icons-material/Remove";
import Avatar from "@mui/material/Avatar/Avatar";
import { circularProgressClasses, styled } from "@mui/material";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import AddIcon from "@mui/icons-material/Add";
import firebase from "../../../firebase/firebase";
import { useFormik, FieldArray, getIn, FormikProvider } from "formik";
import { AuthUserContext } from "../../../providers/AuthProvider";
import ProjectSetup from "../../../validation/project-setup";
import TableRow from "@mui/material/TableRow/TableRow";
import TableCell from "@mui/material/TableCell/TableCell";
import { useNavigate, useParams } from "react-router-dom";
import CircularProgress, {
	CircularProgressProps,
} from "@mui/material/CircularProgress";
import { CheckCircle } from "@mui/icons-material";
import Box from "@mui/material/Box/Box";
import Fab from "@mui/material/Fab/Fab";
import ClearIcon from "@mui/icons-material/Clear";
import ScrollToTop from "../../../utils/scrollTop";
const preTags = [
  "Feature Films",
  "Documentaries",
  "Animations",
  "Indie Shorts",
  "Anime",
  "TV Drama",
  "Comedy",
  "Horror",
  "Kdrama",
  "Cdrama",
  "Other",
  "All",
];

const geoTags = [
  "Asia",
  "Europe",
  "America",
  "Africa",
  "Australia",
  "South Korea",
  "China",
  "India",
  "Nigeria",
  "Spain",
  "U.K",
  "U.S.A",
  "Brazil",
  "Other",
  "All",
];
function StepTwoTeamDetails() {
  const storageRef = firebase.storage().ref();

  const navigator = useNavigate();

  let { projectId } = useParams();

  const { user, profile } = React.useContext(AuthUserContext);

  const Input = styled("input")({
    display: "none",
  });
  const [files, setFiles] = React.useState();
  const [progress , setProgress] = React.useState({
    "director" : null ,
    "producers" : null ,
    "cinematographers" : null,
    "casts" : null
  });

  const Quit = () => {
    navigator(`/creator/projects/list`);
  }
  
  const formik = useFormik({
    initialValues: ProjectSetup.StepTwoTeamInitialValues,
    validationSchema: ProjectSetup.StepTwoTeamSchema,
    onSubmit: async (values) => {
      /*
       * TODO  document update  {projects} collection
       * */

      const casts = values.casts.map((d) => ({
        name: d.name,
        role: d.role,
        character: d.character,
        avatar: d.documentPath || "",
      }));
      const producers = values.producers.map((d) => ({
        producer: d.producer,
        documentPath: d?.documentPath || "",
      }));
      const directors = values.directors.map((d) => ({
        director: d.director,
        documentPath: d?.documentPath || "",
      }));
      const cinematographers = values.cinematographers.map((d) => ({
        cinematographer: d.cinematographer,
        documentPath: d?.documentPath || "",
      }));
      // console.log(`Step two form data post`);
      const projectRef = firebase
        .firestore()
        .collection("projects")
        .doc(projectId);
      await projectRef.update({
        casts,
        producers,
        directors,
        cinematographers,
        updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
      });
      navigator(`/creator/projects/add/step/3/${projectId}`);
    },
  });
  const uploadFile = (type, formHelper, index) => {
    const file = formHelper.form.values[type][index].document;
    const path = `projects/${type}/${user?.uid}/${file.name}`;
    const uploadTask = storageRef.child(path).put(file);
    uploadTask.on(
      "state_changed",
      (snapshot) => {
        // Observe state change events such as progress, pause, and resume
        // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
        const progress =
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          setProgress(prev=> ({ ...prev, [type]: progress }))
        console.log("Upload is " + progress + "% done");
        switch (snapshot.state) {
          case firebase.storage.TaskState.PAUSED: // or 'paused'
            console.log("Upload is paused");
            break;
          case firebase.storage.TaskState.RUNNING: // or 'running'
            console.log("Upload is running");
            break;
        }
      },
      (error) => {},
      () => {
        formHelper.replace(index, {
          ...formHelper.form.values[type][index],
          documentPath: path,
        });
      }
    );
  };

  return (
    <React.Fragment>
      	<ScrollToTop/>
      <GlobalStyles
        styles={{ ul: { margin: 0, padding: 0, listStyle: "none" } }}
      />
      {/* Hero unit */}
      {/*<TopBar showBar={true}/>*/}
      <StepperProjectSetup stepNumber={2} />
      <Container maxWidth="md" sx={{ py: 5 }}>
        <FormikProvider value={formik}>
          <Stack
            direction={"column"}
            justifyContent="flex-start"
            component="form"
            onSubmit={formik.handleSubmit}
            spacing={5}
            sx={{ width: "100%" }}
          >
            <Typography variant={"h5"} sx={{ textAlign: "left" }}>
              Artist
            </Typography>
            <FieldArray
              name={"directors"}
              render={(arrayHelpers) => {
                return (
                  <Stack direction="column"
                         justifyContent="flex-start" alignItems="stretch" spacing={5}>
                    {arrayHelpers?.form.values.directors.map((director, i) => (
                      <Stack
                        direction="column"
                        justifyContent="flex-start"
                        alignItems="stretch"
                        spacing={5} key={`dir${i}`}
                      >
                        <TextField
                          fullWidth
                          label={"Director"}
                          name={`directors.${i}.director`}
                          value={formik.values.directors[i].director}
                          onChange={formik.handleChange}
                          error={
                            getIn(formik.touched, `directors.${i}.director`)
                            && getIn(formik.errors, `directors.${i}.director`)

                       /*     formik.touched &&
                            formik.touched.directors !== undefined &&
                            formik.errors.directors !== undefined &&
                            formik.touched.directors[i].director &&
                            Boolean(formik.errors.directors[i].director)*/
                          }
                          helperText={
                            getIn(formik.touched, `directors.${i}.director`)
                            && getIn(formik.errors, `directors.${i}.director`) &&
                            formik.errors.directors[i].director
                          }
                        />
                        <Stack
                          direction="row"
                          justifyContent="flex-start"
                          alignItems="center"
                          spacing={5}
                        >
                          <HelpOutlineIcon style={{ color: "#c0c0c0" }} />

                          <label
                            htmlFor={`directors-${i}`}
                            style={{ width: "100%" }}
                          >
                            <Button
                              variant={"outlined"}
                              sx={{ py: 1.2, px: 5, borderRadius: 0 }}
                              fullWidth
                              component={"span"}
                              startIcon={<UploadFileIcon />}
                            >
                              Upload evidence
                            </Button>
                            <Input
                              accept="**/*"
                              id={`directors-${i}`}
                              multiple={false}
                              type="file"
                              onChange={(e) => {
                                arrayHelpers.replace(i, {
                                  ...arrayHelpers.form.values.directors[i],
                                  document: e.target.files[0],
                                  progress: 0,
                                });
                              }}
                            />
                          </label>

                          <Button
                            variant={"contained"}
                            sx={{ py: 1.3, px: 5, borderRadius: 0 }}
                            onClick={() => {
                              uploadFile("directors", arrayHelpers, i);
                            }}
                          >
                            Upload
                          </Button>
                        </Stack>
                        {formik.values.directors[i].document !== undefined && (
                          <Stack
                            direction="row"
                            justifyContent="flex-start"
                            alignItems="center"
                            spacing={2}
                            sx={{
                              borderBottom: "1px solid #204488",
                              paddingY: 2,
                            }}
                          >
                            <Stack
                              direction="row"
                              justifyContent="flex-start"
                              alignItems="center"
                              spacing={2}
                              sx={{ flex: 1 }}
                            >
                              {progress.directors > 0 && progress.directors < 100 ? (
                                  <CircularProgress
                                    variant="indeterminate"
                                    disableShrink
                                    sx={{
                                      color: (theme) =>
                                        theme.palette.mode === "light"
                                          ? "#b9b9bc"
                                          : "#909093",
                                      animationDuration: "550ms",
                                      left: 0,
                                      [`& .${circularProgressClasses.circle}`]:
                                        {
                                          strokeLinecap: "round",
                                        },
                                    }}
                                    size={30}
                                    thickness={4}
                                    // {...props}
                                  />
                                ) : (
                                  <>
                                  {progress.directors === 100 && <CheckCircle color={"primary"} style={{ height: 20, width: 20}}/>}
                                  {!progress.directors && 
                                    <img
                                    src="/assets/icons/file-upload.png"
                                    style={{ height: 20, width: 20 }}
                                    alt=""
                                    />
                                  }
                                  </>
                                  
                                )}
                              {/* <img
                                src="/assets/icons/file-upload.png"
                                style={{ height: 20, width: 20 }}
                                alt=""
                              /> */}

                              <Typography color={"primary"}>
                                {formik.values.directors[i].document?.name}
                              </Typography>
                            </Stack>
                            <Box
                              sx={{
                                paddingX: 2,
                                borderRight: "1px solid #ccc",
                              }}
                            >
                              <Box
                                sx={{
                                  p: 1,
                                  background: "#204488",
                                  fontSize: "small",
                                  color: "#fff",
                                }}
                              >
                                {(
                                  formik.values.directors[i].document?.size /
                                  1024 /
                                  1024
                                ).toFixed(0) == 0
                                  ? (
                                      formik.values.directors[i].document
                                        ?.size / 1024
                                    ).toFixed(0) + " KB"
                                  : (
                                      formik.values.directors[i].document
                                        ?.size /
                                      1024 /
                                      1024
                                    ).toFixed(0) + " MB"}
                              </Box>
                            </Box>
                            <Fab
                              color={"primary"}
                              sx={{ boxShadow: "none" }}
                              size={"small"}
                              aria-label="delete"
                              onClick={() => {
                                delete arrayHelpers.form.values.directors[i]
                                  .document;
                                arrayHelpers.replace(i, {
                                  ...arrayHelpers.form.values.directors[i],
                                });
                              }}
                            >
                              <ClearIcon />
                            </Fab>
                          </Stack>
                        )}
                        {
												arrayHelpers.form.values.directors.length > 1 &&
												

												<Button  onClick={() => {
												
													arrayHelpers.remove(i);
												}}
												variant={"outlined"}
												sx={{
													borderRadius: 0,
													mt: 3,
													ml: 2,
													width: 200,
												}}
												startIcon={<RemoveIcon />}>
												Remove
											</Button>
									
													}
                      </Stack>
                    ))}
                    <Stack direction="row">
                    <Button
                      onClick={() => {
                       
                        arrayHelpers.push({
                         
                          id: Math.random(),
                          director: "",
                          
                        });
                      }}
                      style={{width:"200px"}}
                      variant={"outlined"}
                      sx={{ borderRadius: 0, mt: 3}}
                      startIcon={<AddIcon />}
                    >
                      Add another
                     
                    </Button>
                 
                    </Stack>
                  </Stack>
                );
              }}
            />

            <FieldArray
              name={"producers"}
              render={(arrayHelpers) => {
                return (
                  <Stack direction="column"
                         justifyContent="flex-start" alignItems="stretch" spacing={5}>
                    {arrayHelpers?.form.values.producers.map((producer, i) => (
                      <Stack
                        direction="column"
                        justifyContent="flex-start"
                        alignItems="stretch"
                        spacing={5}
                      >
                        <TextField
                          fullWidth
                          label={"Producer"}
                          name={`producers.${i}.producer`}
                          value={formik.values.producers[i].producer}
                          onChange={formik.handleChange}
                          error={
                            getIn(formik.touched, `producers.${i}.producer`)
                            && getIn(formik.errors, `producers.${i}.producer`)
                           /* formik.touched &&
                            formik.touched.producers !== undefined &&
                            formik.errors.producers !== undefined &&
                            formik.touched.producers[i].producer &&
                            Boolean(formik.errors.producers[i].producer)*/
                          }
                          helperText={
                            getIn(formik.touched, `producers.${i}.producer`)
                            && getIn(formik.errors, `producers.${i}.producer`) &&
                            formik.errors.producers[i].producer
                          }
                        />
                        <Stack
                          direction="row"
                          justifyContent="flex-start"
                          alignItems="center"
                          spacing={5}
                        >
                          <HelpOutlineIcon style={{ color: "#c0c0c0" }} />

                          <label
                            htmlFor={`producers-${i}`}
                            style={{ width: "100%" }}
                          >
                            <Button
                              variant={"outlined"}
                              sx={{ py: 1.3, borderRadius: 0 }}
                              fullWidth
                              component={"span"}
                              startIcon={<UploadFileIcon />}
                            >
                              Upload evidence
                            </Button>
                            <Input
                              accept="**/*"
                              id={`producers-${i}`}
                              multiple={false}
                              type="file"
                              onChange={(e) => {
                                arrayHelpers.replace(i, {
                                  ...arrayHelpers.form.values.producers[i],
                                  document: e.target.files[0],
                                  progress: 0,
                                });
                              }}
                            />
                          </label>

                          <Button
                            variant={"contained"}
                            sx={{ py: 1.3, px: 5, borderRadius: 0 }}
                            onClick={() => {
                              uploadFile("producers", arrayHelpers, i);
                            }}
                          >
                            Upload
                          </Button>
                        </Stack>
                        {formik.values.producers[i].document !== undefined && (
                          <Stack
                            direction="row"
                            justifyContent="flex-start"
                            alignItems="center"
                            spacing={2}
                            sx={{
                              borderBottom: "1px solid #204488",
                              paddingY: 2,
                            }}
                          >
                            <Stack
                              direction="row"
                              justifyContent="flex-start"
                              alignItems="center"
                              spacing={2}
                              sx={{ flex: 1 }}
                            >
                              {progress.producers > 0 && progress.producers < 100 ? (
                                  <CircularProgress
                                    variant="indeterminate"
                                    disableShrink
                                    sx={{
                                      color: (theme) =>
                                        theme.palette.mode === "light"
                                          ? "#b9b9bc"
                                          : "#909093",
                                      animationDuration: "550ms",
                                      left: 0,
                                      [`& .${circularProgressClasses.circle}`]:
                                        {
                                          strokeLinecap: "round",
                                        },
                                    }}
                                    size={30}
                                    thickness={4}
                                    // {...props}
                                  />
                                ) : (
                                  <>
                                  {progress.producers === 100 && <CheckCircle color={"primary"} style={{ height: 20, width: 20}}/>}
                                  {!progress.producers && 
                                    <img
                                    src="/assets/icons/file-upload.png"
                                    style={{ height: 20, width: 20 }}
                                    alt=""
                                    />
                                  }
                                  </>
                                  
                                )}
                              {/* <img
                                src="/assets/icons/file-upload.png"
                                style={{ height: 20, width: 20 }}
                                alt=""
                              /> */}

                              <Typography color={"primary"}>
                                {formik.values.producers[i].document?.name}
                              </Typography>
                            </Stack>
                            <Box
                              sx={{
                                paddingX: 2,
                                borderRight: "1px solid #ccc",
                              }}
                            >
                              <Box
                                sx={{
                                  p: 1,
                                  background: "#204488",
                                  fontSize: "small",
                                  color: "#fff",
                                }}
                              >
                                {(
                                  formik.values.producers[i].document?.size /
                                  1024 /
                                  1024
                                ).toFixed(0) == 0
                                  ? (
                                      formik.values.producers[i].document
                                        ?.size / 1024
                                    ).toFixed(0) + " KB"
                                  : (
                                      formik.values.producers[i].document
                                        ?.size /
                                      1024 /
                                      1024
                                    ).toFixed(0) + " MB"}
                              </Box>
                            </Box>
                            <Fab
                              color={"primary"}
                              sx={{ boxShadow: "none" }}
                              size={"small"}
                              aria-label="delete"
                              onClick={() => {
                                delete arrayHelpers.form.values.producers[i]
                                  .document;
                                arrayHelpers.replace(i, {
                                  ...arrayHelpers.form.values.producers[i],
                                });
                              }}
                            >
                              <ClearIcon />
                            </Fab>
                          </Stack>
                        )}
                        {
												arrayHelpers.form.values.producers.length > 1 &&
												


												<Button  onClick={() => {
												
													arrayHelpers.remove(i);
												}}
												variant={"outlined"}
												sx={{
													borderRadius: 0,
													mt: 3,
													width: 200,
												}}
												startIcon={<RemoveIcon />}>
												Remove
											</Button>
									
													}
                      </Stack>
                    ))}
                    <Stack direction="row">
                    <Button
                      onClick={() => {

                        arrayHelpers.push({ id: Math.random(), producer: "" });
                      }}
                      style={{width:"200px"}}
                      variant={"outlined"}
                      sx={{ borderRadius: 0, mt: 3,  }}
                      startIcon={<AddIcon />}
                    >
                      Add another
                      
                    </Button>
                  
                    </Stack>
                  </Stack>
                );
              }}
            />

            <FieldArray
              name={"cinematographers"}
              render={(arrayHelpers) => {
                return (
                  <Stack direction="column"
                         justifyContent="flex-start" alignItems="stretch" spacing={5}>
                    {arrayHelpers?.form.values.cinematographers.map(
                      (cinematographer, i) => (
                        <Stack
                          direction="column"
                          justifyContent="flex-start"
                          alignItems="stretch"
                          spacing={5}
                        >
                          <TextField
                            fullWidth
                            label={"Cinematographer"}
                            name={`cinematographers.${i}.cinematographer`}
                            value={
                              formik.values.cinematographers[i].cinematographer
                            }
                            onChange={formik.handleChange}
                            error={
                              getIn(formik.touched, `cinematographers.${i}.cinematographer`)
                              && getIn(formik.errors, `cinematographers.${i}.cinematographer`)
                            /*
                              formik.touched &&
                              formik.touched.cinematographers !== undefined &&
                              formik.errors.cinematographers !== undefined &&
                              formik.touched.cinematographers[i]
                                .cinematographer &&
                              Boolean(
                                formik.errors.cinematographers[i]
                                  .cinematographer
                              )*/
                            }
                            helperText={
                              getIn(formik.touched, `cinematographers.${i}.cinematographer`)
                              && getIn(formik.errors, `cinematographers.${i}.cinematographer`) &&
                              formik.errors.cinematographers[i].cinematographer
                            }
                          />
                          <Stack
                            direction="row"
                            justifyContent="flex-start"
                            alignItems="center"
                            spacing={5}
                          >
                            <HelpOutlineIcon style={{ color: "#c0c0c0" }} />

                            <label
                              htmlFor={`cinematographers-${i}`}
                              style={{ width: "100%" }}
                            >
                              <Button
                                variant={"outlined"}
                                sx={{ py: 1.3, borderRadius: 0 }}
                                fullWidth
                                component={"span"}
                                startIcon={<UploadFileIcon />}
                              >
                                Upload evidence
                              </Button>
                              <Input
                                accept="**/*"
                                id={`cinematographers-${i}`}
                                multiple={false}
                                type="file"
                                onChange={(e) => {
                                  arrayHelpers.replace(i, {
                                    ...arrayHelpers.form.values
                                      .cinematographers[i],
                                    document: e.target.files[0],
                                    progress: 0,
                                  });
                                }}
                              />
                            </label>

                            <Button
                              variant={"contained"}
                              sx={{ py: 1.3, px: 5, borderRadius: 0 }}
                              onClick={() => {
                                uploadFile("cinematographers", arrayHelpers, i);
                              }}
                            >
                              Upload
                            </Button>
                          </Stack>
                          {formik.values.cinematographers[i].document !==
                            undefined && (
                            <Stack
                              direction="row"
                              justifyContent="flex-start"
                              alignItems="center"
                              spacing={2}
                              sx={{
                                borderBottom: "1px solid #204488",
                                paddingY: 2,
                              }}
                            >
                              <Stack
                                direction="row"
                                justifyContent="flex-start"
                                alignItems="center"
                                spacing={2}
                                sx={{ flex: 1 }}
                              >
                                {progress.cinematographers > 0 && progress.cinematographers < 100 ? (
                                  <CircularProgress
                                    variant="indeterminate"
                                    disableShrink
                                    sx={{
                                      color: (theme) =>
                                        theme.palette.mode === "light"
                                          ? "#b9b9bc"
                                          : "#909093",
                                      animationDuration: "550ms",
                                      left: 0,
                                      [`& .${circularProgressClasses.circle}`]:
                                        {
                                          strokeLinecap: "round",
                                        },
                                    }}
                                    size={30}
                                    thickness={4}
                                    // {...props}
                                  />
                                ) : (
                                  <>
                                  {progress.cinematographers === 100 && <CheckCircle color={"primary"} style={{ height: 20, width: 20}}/>}
                                  {!progress.cinematographers && 
                                    <img
                                    src="/assets/icons/file-upload.png"
                                    style={{ height: 20, width: 20 }}
                                    alt=""
                                    />
                                  }
                                  </>
                                  
                                )}
                                {/* <img
                                  src="/assets/icons/file-upload.png"
                                  style={{ height: 20, width: 20 }}
                                  alt=""
                                /> */}

                                <Typography color={"primary"}>
                                  {
                                    formik.values.cinematographers[i].document
                                      ?.name
                                  }
                                </Typography>
                              </Stack>
                              <Box
                                sx={{
                                  paddingX: 2,
                                  borderRight: "1px solid #ccc",
                                }}
                              >
                                <Box
                                  sx={{
                                    p: 1,
                                    background: "#204488",
                                    fontSize: "small",
                                    color: "#fff",
                                  }}
                                >
                                  {(
                                    formik.values.cinematographers[i].document
                                      ?.size /
                                    1024 /
                                    1024
                                  ).toFixed(0) == 0
                                    ? (
                                        formik.values.cinematographers[i]
                                          .document?.size / 1024
                                      ).toFixed(0) + " KB"
                                    : (
                                        formik.values.cinematographers[i]
                                          .document?.size /
                                        1024 /
                                        1024
                                      ).toFixed(0) + " MB"}
                                </Box>
                              </Box>
                              <Fab
                                color={"primary"}
                                sx={{ boxShadow: "none" }}
                                size={"small"}
                                aria-label="delete"
                                onClick={() => {
                                  delete arrayHelpers.form.values
                                    .cinematographers[i].document;
                                  arrayHelpers.replace(i, {
                                    ...arrayHelpers.form.values
                                      .cinematographers[i],
                                  });
                                }}
                              >
                                <ClearIcon />
                              </Fab>
                            </Stack>
                          )}
                          {
												arrayHelpers.form.values.cinematographers.length > 1 &&

												<Button  onClick={() => {
												
                        
													arrayHelpers.remove(i);
												}}
												variant={"outlined"}
												sx={{
													borderRadius: 0,
													mt: 3,
											
													width: 200,
												}}
												startIcon={<RemoveIcon />}>
												Remove
											</Button>
										
													}
                        </Stack>
                      )
                    )}
                    <Stack direction="row">
                    <Button
                      onClick={() => {
                       
                        arrayHelpers.push({
                          id: Math.random(),
                          cinematographer: "",
                        });
                      }}
                      style={{width:"200px"}}
                      variant={"outlined"}
                      sx={{ borderRadius: 0, mt: 3}}
                      startIcon={<AddIcon />}
                    >
                      Add another
                  
                    </Button>
                  
                    </Stack>
                  </Stack>
                );
              }}
            />

            <Typography variant={"h5"} sx={{ textAlign: "left" }}>
              Cast
            </Typography>

            <FieldArray
              name={"casts"}
              render={(arrayHelpers) => {
                return (
                  <Stack direction="column"
                         justifyContent="flex-start" alignItems="stretch" spacing={5}>
                    {arrayHelpers?.form.values.casts.map((cast, i) => (
                      <>
                        <Stack
                          direction="row"
                          justifyContent="flex-start"
                          alignItems="center"
                          spacing={5}
                        >
                          <label htmlFor={`casts-${i}`}>
                            <Avatar
                              alt={"Tabain"}
                              src={
                                arrayHelpers.form.values.casts[i]?.src
                                  ? arrayHelpers.form.values.casts[i]?.src
                                  : "/assets/default-avatar.png"
                              }
                              sx={{
                                width: 150,
                                height: 150,
                                cursor: "pointer",
                                objectFit: "contain",
                              }}
                              imgProps={{ sx: { objectFit: "contain" } }}
                              component={"span"}
                            />
                            <Input
                              accept="image/*"
                              id={`casts-${i}`}
                              multiple={false}
                              type="file"
                              onChange={(e) => {
                                const fileReader = new FileReader();
                                fileReader.readAsDataURL(e.target.files[0]);
                                fileReader.addEventListener(
                                  "load",
                                  async function () {
                                    arrayHelpers.replace(i, {
                                      ...arrayHelpers.form.values.casts[i],
                                      src: this.result,
                                      document: e.target.files[0],
                                      progress: 0,
                                    });
                                    // setProfileImage({
                                    //   src: this.result,
                                    //   file: e.target.files[0],
                                    //   size:  (e.target.files[0]?.size / 1024 / 1024).toFixed(2)
                                    //
                                    //
                                    // });
                                  }
                                );
                              }}
                            />
                          </label>
                          <Button
                            sx={{ py: 1.3, px: 3 }}
                            onClick={() => {
                              delete arrayHelpers.form.values.casts[i].document;
                              delete arrayHelpers.form.values.casts[i].src;
                              arrayHelpers.replace(i, {
                                ...arrayHelpers.form.values.casts[i],
                              });
                            }}
                          >
                            Remove picture
                          </Button>

                          <Button
                            variant={"outlined"}
                            sx={{ py: 1.3, px: 5 }}
                            onClick={() => uploadFile("casts", arrayHelpers, i)}
                          >
                            Upload
                            {progress.casts === 100 &&
																	 <CheckCircle style={{marginLeft: '15px'}}/>}
																	{progress.casts >0 && progress.casts <100 &&
																	<CircularProgress sx={{ml: 2}} size={20} color="primary"/>
																	}
                          </Button>
                        </Stack>
                        <TextField
                          label={"Role"}
                          style ={{ textAlign : "left"}}
                          select
                          name={`casts.${i}.role`}
                          value={formik.values.casts[i].role}
                          onChange={formik.handleChange}
                          error={
                            getIn(formik.touched, `casts.${i}.role`)
                            && getIn(formik.errors, `casts.${i}.role`)
                            /*formik.touched &&
                            formik.touched.casts !== undefined &&
                            formik.errors.casts !== undefined &&
                            formik.touched.casts[i].role &&
                            Boolean(formik.errors.casts[i].role)*/
                          }
                          helperText={
                            getIn(formik.touched, `casts.${i}.role`)
                            && getIn(formik.errors, `casts.${i}.role`) &&
                            formik.errors.casts[i].role
                          }
                        >
                          <MenuItem value={"Actor"}>Actor</MenuItem>
                          <MenuItem value={"Actress"}>Actress</MenuItem>
                          <MenuItem value={"Voice Over"}>Voice Over</MenuItem>
                        </TextField>

                        <TextField
                          label={"Character"}
                          name="character"
                          name={`casts.${i}.character`}
                          value={formik.values.casts[i].character}
                          onChange={formik.handleChange}
                          error={
                            getIn(formik.touched, `casts.${i}.character`)
                            && getIn(formik.errors, `casts.${i}.character`)
                            /*
                                  formik.touched &&
                                  formik.touched.casts !== undefined &&
                                  formik.errors.casts !== undefined &&
                                  formik.touched.casts[i].character &&
                                  Boolean(formik.errors.casts[i].character)*/
                          }
                          helperText={
                            getIn(formik.touched, `casts.${i}.character`)
                            && getIn(formik.errors, `casts.${i}.character`) &&
                            formik.errors.casts[i].character
                          }
                        />
                        <TextField
                          label={"Name"}
                          name={`casts.${i}.name`}
                          value={formik.values.casts[i].name}
                          onChange={formik.handleChange}
                          error={
                            getIn(formik.touched, `casts.${i}.name`)
                            && getIn(formik.errors, `casts.${i}.name`)
                            /*formik.touched &&
                            formik.touched.casts !== undefined &&
                            formik.errors.casts !== undefined &&
                            formik.touched.casts[i].name &&
                            Boolean(formik.errors.casts[i].name)*/
                          }
                          helperText={
                            getIn(formik.touched, `casts.${i}.name`)
                            && getIn(formik.errors, `casts.${i}.name`) &&
                            formik.errors.casts[i].name
                          }
                        />
                          {arrayHelpers.form.values.casts.length > 1 &&<Button  onClick={() => {
												
                        arrayHelpers.remove(i);
                      }}
                      variant={"outlined"}
                      sx={{
                        borderRadius: 0,
                        mt: 3,
                      
                        width: 200,
                      }}
                      startIcon={<RemoveIcon />}>
                      Remove
                    </Button>
                  
                        }

                      </>
                    ))}
                    <Stack direction="row">
                    <Button
                      onClick={() => {
                        arrayHelpers.push({
                          id: Math.random(),
                          name: "",
                          character: "",
                          role: "",
                        });
                      }}
                      style={{width:"200px"}}
                      variant={"outlined"}
                      sx={{ borderRadius: 0, mt: 3,  }}
                      startIcon={<AddIcon />}
                    >
                      Add another
                    </Button>
                  
                    </Stack>
                  </Stack>
                );
              }}
            />

            <Stack
              spacing={2}
              direction="row"
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Button
                sx={{
                  pt: 1.2,
                  pb: 1.2,
                  pl: 5,
                  pr: 5,
                  textDecoration: "underline",
                }}
                onClick = {Quit}
              >
                Quit without saving
              </Button>

              <Button
                variant="contained"
                sx={{ pt: 1.2, pb: 1.2, pl: 5, pr: 5 }}
                type={"submit"}
              >
                Next
              </Button>
            </Stack>
          </Stack>
        </FormikProvider>
      </Container>
    </React.Fragment>
  );
}
export default StepTwoTeamDetails;
